import { createContext, useContext } from 'react';
export const RadioGroupContext = createContext(undefined);
export const useRadioGroupContext = () => {
    const contextValue = useContext(RadioGroupContext);
    if (contextValue === undefined) {
        throw new Error('You can not use RadioGroup.Radio component outside RadioGroup');
    }
    return contextValue;
};
//# sourceMappingURL=context.js.map